const customerEnumerators = {
  gender: [
    'male',
    'female',
    'other',
  ],
}

export default customerEnumerators
